webpackJsonp([77196258398326],{

/***/ 143:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _post = __webpack_require__(252);
	
	var _post2 = _interopRequireDefault(_post);
	
	var _layoutPost = __webpack_require__(143);
	
	var _layoutPost2 = _interopRequireDefault(_layoutPost);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_post2.default, _extends({}, props, _layoutPost2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header":"src-components-Header----header-module---Header---10RMb","Items":"src-components-Header----header-module---Items---1fEP9","Icons":"src-components-Header----header-module---Icons---1A3Rr"};

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HeaderItem = __webpack_require__(31);
	
	var _HeaderItem2 = _interopRequireDefault(_HeaderItem);
	
	var _headerModule = __webpack_require__(35);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	var _Layout = __webpack_require__(24);
	
	var _Grid = __webpack_require__(57);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _github = __webpack_require__(22);
	
	var _github2 = _interopRequireDefault(_github);
	
	var _bio = __webpack_require__(38);
	
	var _bio2 = _interopRequireDefault(_bio);
	
	var _twitter = __webpack_require__(39);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _headerModule2.default.Header },
	    _react2.default.createElement(
	      _Layout.Container,
	      null,
	      _react2.default.createElement(
	        _Grid2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.Items },
	          _react2.default.createElement(_HeaderItem2.default, { title: 'Home', to: '/' }),
	          _react2.default.createElement(_HeaderItem2.default, { title: 'Blog', to: '/blog/' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.Icons },
	          _react2.default.createElement(_Icon2.default, {
	            src: _twitter2.default,
	            alt: 'Twitter icon',
	            to: 'https://twitter.com/theomjones'
	          }),
	          _react2.default.createElement(_Icon2.default, {
	            src: _github2.default,
	            alt: 'Github Icon',
	            to: 'https://github.com/theomjones'
	          }),
	          _react2.default.createElement(_Icon2.default, {
	            src: _bio2.default,
	            alt: 'Bio Icon',
	            round: true,
	            shadow: true,
	            to: 'https://www.linkedin.com/in/theomjones/'
	          })
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"HeaderItem":"src-components-HeaderItem----headerItem-module---HeaderItem---9cRP9","active":"src-components-HeaderItem----headerItem-module---active---1MnxB"};

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _headerItemModule = __webpack_require__(36);
	
	var _headerItemModule2 = _interopRequireDefault(_headerItemModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _headerItemModule2.default.HeaderItem },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { exact: true, to: props.to, activeClassName: _headerItemModule2.default.active },
	      props.title
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Icon":"src-components-Icon----Icon-module---Icon---3TdpF","isLink":"src-components-Icon----Icon-module---isLink---e7Phv"};

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconModule = __webpack_require__(14);
	
	var _IconModule2 = _interopRequireDefault(_IconModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param {props} Object
	 * @prop {src} String
	 * @prop {alt} String
	 * @prop {round} Bool
	 * @prop {shadow} Bool
	 * @prop {to} String
	 */
	var Icon = function Icon(_ref) {
	  var src = _ref.src,
	      alt = _ref.alt,
	      round = _ref.round,
	      shadow = _ref.shadow,
	      to = _ref.to,
	      size = _ref.size;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _IconModule2.default.Icon,
	      title: to ? to : '',
	      onClick: function onClick() {
	        if (to) {
	          window.open(to, '_blank');
	        }
	        return;
	      },
	      style: {
	        height: size ? size + 'px' : null,
	        width: size ? size + 'px' : null
	      }
	    },
	    _react2.default.createElement('img', {
	      className: to && _IconModule2.default.isLink,
	      style: {
	        borderRadius: round && '50%',
	        boxShadow: shadow && '-1px 2px 2px rgba(0, 0, 0, 0.2)'
	      },
	      src: src,
	      alt: alt
	    })
	  );
	};
	
	Icon.propTypes = {
	  /** Src is string */
	  src: _propTypes2.default.string.isRequired,
	  alt: _propTypes2.default.string.isRequired,
	  round: _propTypes2.default.bool,
	  shadow: _propTypes2.default.bool,
	  to: _propTypes2.default.string,
	  height: _propTypes2.default.number,
	  width: _propTypes2.default.number
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWxhYmVsbGVkYnk9InNpbXBsZWljb25zLWdpdGh1Yi1pY29uIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGUgaWQ9InNpbXBsZWljb25zLWdpdGh1Yi1pY29uIj5HaXRIdWIgaWNvbjwvdGl0bGU+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIC4yOTdjLTYuNjMgMC0xMiA1LjM3My0xMiAxMiAwIDUuMzAzIDMuNDM4IDkuOCA4LjIwNSAxMS4zODUuNi4xMTMuODItLjI1OC44Mi0uNTc3IDAtLjI4NS0uMDEtMS4wNC0uMDE1LTIuMDQtMy4zMzguNzI0LTQuMDQyLTEuNjEtNC4wNDItMS42MUM0LjQyMiAxOC4wNyAzLjYzMyAxNy43IDMuNjMzIDE3LjdjLTEuMDg3LS43NDQuMDg0LS43MjkuMDg0LS43MjkgMS4yMDUuMDg0IDEuODM4IDEuMjM2IDEuODM4IDEuMjM2IDEuMDcgMS44MzUgMi44MDkgMS4zMDUgMy40OTUuOTk4LjEwOC0uNzc2LjQxNy0xLjMwNS43Ni0xLjYwNS0yLjY2NS0uMy01LjQ2Ni0xLjMzMi01LjQ2Ni01LjkzIDAtMS4zMS40NjUtMi4zOCAxLjIzNS0zLjIyLS4xMzUtLjMwMy0uNTQtMS41MjMuMTA1LTMuMTc2IDAgMCAxLjAwNS0uMzIyIDMuMyAxLjIzLjk2LS4yNjcgMS45OC0uMzk5IDMtLjQwNSAxLjAyLjAwNiAyLjA0LjEzOCAzIC40MDUgMi4yOC0xLjU1MiAzLjI4NS0xLjIzIDMuMjg1LTEuMjMuNjQ1IDEuNjUzLjI0IDIuODczLjEyIDMuMTc2Ljc2NS44NCAxLjIzIDEuOTEgMS4yMyAzLjIyIDAgNC42MS0yLjgwNSA1LjYyNS01LjQ3NSA1LjkyLjQyLjM2LjgxIDEuMDk2LjgxIDIuMjIgMCAxLjYwNi0uMDE1IDIuODk2LS4wMTUgMy4yODYgMCAuMzE1LjIxLjY5LjgyNS41N0MyMC41NjUgMjIuMDkyIDI0IDE3LjU5MiAyNCAxMi4yOTdjMC02LjYyNy01LjM3My0xMi0xMi0xMiIvPjwvc3ZnPgo="

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU2IiBoZWlnaHQ9IjIwOSIgdmlld0JveD0iMCAwIDI1NiAyMDkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCI+CiAgPHBhdGggZD0iTTI1NiAyNS40NTAwMjU5Yy05LjQxOTE1OSA0LjE3NzI0MTMtMTkuNTQxNTQ5IDcuMDAwNDYwOS0zMC4xNjU4NDQgOC4yNzAyMDc0IDEwLjg0NDM0Ny02LjUwMDQyOCAxOS4xNzE2NzQtMTYuNzkzMjQwNCAyMy4wOTMyODEtMjkuMDU3MTU2NDVDMjM4Ljc3OTc2NSAxMC42ODEyNjMzIDIyNy41MzkzMjUgMTUuMDUyMzM3NiAyMTUuNTc1OTkgMTcuNDA4Mjk4IDIwNS45OTQ4MzUgNy4yMDA2OTcxIDE5Mi4zNDUwNi44MjIgMTc3LjIzOTE5Ny44MjJjLTI5LjAwNjU5MiAwLTUyLjUyMzEyMSAyMy41MTU1OTMxLTUyLjUyMzEyMSA1Mi41MjAzMTE2IDAgNC4xMTYzNzU5LjQ2NTM4NiA4LjEyNTA2NjggMS4zNjA1NzYgMTEuOTY4OTUyOEM4Mi40MjU4Mzg1IDYzLjEyMTA0NTMgNDMuNzI1NzI1MiA0Mi4yMTE0MjkgMTcuODIxMzk4IDEwLjQzNTkyODhjLTQuNTIwODk2OSA3Ljc1NzA2NS03LjExMDk1NSAxNi43NzkxOTQ2LTcuMTEwOTU1IDI2LjQwNDM2MDEgMCAxOC4yMjEyMzcxIDkuMjczMDgyNCAzNC4yOTcyMDE4IDIzLjM2NTc3MDUgNDMuNzE1NDI0OC04LjYxMDExNzQtLjI3MjQ4OTgtMTYuNzA4MDI4OS0yLjYzNTAwNDktMjMuNzg5OTU1OC02LjU2ODc4NDUtLjAwMzc0NTUuMjE5MTE1Ni0uMDAzNzQ1NS40MzkxNjc1LS4wMDM3NDU1LjY2MDE1NTggMCAyNS40NDczNjggMTguMTA0MTg4MSA0Ni42NzUzNTggNDIuMTMxMDUwOCA1MS40OTk2NDUtNC40MDc1OTM1IDEuMjAwNDU0LTkuMDQ3NDEyMSAxLjg0MTg4Mi0xMy44Mzc5ODk2IDEuODQxODgyLTMuMzg0MTE4IDAtNi42NzQ1OTY4LS4zMjg2NzQtOS44ODA4MDA0LS45NDIwMSA2LjY4MzAyNDMgMjAuODY2NTQzIDI2LjA3OTQzMjMgMzYuMDUxMDYzIDQ5LjA2MjIxODggMzYuNDc1MjQ4LTE3Ljk3NDk2NjEgMTQuMDg2MTMzLTQwLjYyMTU4ODIgMjIuNDgyNzU0LTY1LjIyODA3NzEgMjIuNDgyNzU0LTQuMjM5MDQzMDkgMC04LjQyMDAyOTk2LS4yNDgxNDQtMTIuNTI4OTE0Ny0uNzMzMTk1IDIzLjI0MzEwMzMgMTQuOTAxNzMgNTAuODUwNzI2MSAyMy41OTYxMjMgODAuNTEwOTE4NSAyMy41OTYxMjMgOTYuNjA1NjEwNSAwIDE0OS40MzMwNTg1LTgwLjAzMDU1IDE0OS40MzMwNTg1LTE0OS40MzQ5MzE4IDAtMi4yNzczMDM0LS4wNTA1NjUtNC41NDI0MzM4LS4xNTE2OTUtNi43OTQ0NTQ4QzI0MC4wNTMyNTcgNDUuMjMzMTYzNSAyNDguOTU4MzM4IDM1Ljk4MjU1NDUgMjU2IDI1LjQ1MDAyNTkiIGZpbGw9IiNmZmZmZmYiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(30);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _index = __webpack_require__(56);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Post = function Post(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, null),
	    children()
	  );
	};
	
	Post.propTypes = {
	  children: _propTypes2.default.any.isRequired
	};
	
	exports.default = Post;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-post-js-166a159e5c03d134aaaa.js